/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import store from '@/store';
import ContractApi from '@/api/contract';

import { ContractData } from '@/api/contract/types';
import { ContractEnum } from '@/enums/contract-type';
import { SessionEnum } from '@/enums/session';
import { session } from '@/shared/utils/storage';
import { MASHANG_COMMODITY } from '@/shared/commodity';
import { BaseAgreementData } from '../agreements/base-agreement-data';

export class PWDAgreementData extends BaseAgreementData {
  public init(commodityId: number, type: ContractEnum): void {
    super.init(commodityId, type);
    this.reloadNormal();
  }

  // 2080 马上渠道,方法无调用场景，待删除
  protected api(): Promise<ContractData[]> {
    // 只有马上才有 密码协议
    if (String(this.commodityId) === MASHANG_COMMODITY) {
      const data: Dictionary = session.get(SessionEnum.ApplyProduct) || {};

      // 取到银行卡信息
      const lastInputFromProduct = store.getters['order/getSavedOrderInputs'](
        this.commodityId,
      );

      if (lastInputFromProduct.bankInfo.id) {
        return ContractApi.getDynamicUrl({
          commodityId: this.commodityId,
          type: this.type,
          bankCardId: lastInputFromProduct.bankInfo.id,
          ...data,
        });
      }
    }

    return Promise.resolve([]);
  }
}
